import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import Works from "./pages/Works/Works";
import styled from "styled-components";
import MainGame from "./pages/25/MainGame";
import PlayerView from "./pages/25Juego/components/PlayerView";
import HostView from "./pages/25Juego/components/HostView";
import JoinGame from "./pages/25Juego/components/JoinGame";

// import "./pages/25Juego/index.css";

export const RoutesHelper = {
  main: "/",
  contact: "/contact",
  works: "/works",
  project: "project/1",
  error: "404",
  cumple25: "/25",
};

const Main = () => {
  return (
    <>
      <Routes>
        <Route path={RoutesHelper.main} element={<Home />} />

        {/* <Route path="/host/:gameId?" element={<HostView />} /> */}

        {/* Ruta mágica de entrada para jugadores */}
        {/* <Route path="/join/:gameId" element={<JoinGame />} /> */}

        {/* Vista privada del jugador */}
        {/* <Route path="/game/:gameId/player/:playerId" element={<PlayerView />} /> */}
      </Routes>
    </>
  );
};

export default Main;
